export default {
	getById(id, cb, ecb) {
		this.http
			.get(`/banner/getById/${id}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getByGroups(groups, cb, ecb) {
		this.http
			.get('/banner/getByGroups/' + groups, {
				params: {}
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/banner/search/', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	status(id, to, cb, ecb) {
		this.http
			.get(`/banner/status/${id}/${to}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb, config = {}) {
		this.http
			.post('/banner/update/', form, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
